export default __webpack_public_path__ + "static/media/Hangman1.04119f41.svg";